import { ApiEntity } from '../../models'

export const SET_APIS = 'SET_APIS'
export const SET_APIS_LOADED = 'SET_APIS_LOADED'
export const SET_SELECTED_API = 'SET_SELECTED_API'

export interface ApiState {
  apis: ApiEntity[]
  isApisLoaded: boolean
  selectedApi?: ApiEntity
}

interface SetApisAction {
  type: typeof SET_APIS
  payload: ApiEntity[]
}

interface SetApisLoadedAction {
  type: typeof SET_APIS_LOADED
  payload: boolean
}

interface SetSelectedApiAction {
  type: typeof SET_SELECTED_API
  payload?: ApiEntity
}

export type ApiAction =
  | SetApisAction
  | SetApisLoadedAction
  | SetSelectedApiAction
